import { IEdTabsMenu } from '@/content/interfaces/ed-tabs-menu.interface';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { COURSE_EVENTS } from '@/content/values/events';

@Component({})
class EdTabs extends Vue {
  
  @Prop() readonly menu: IEdTabsMenu[];
  @Prop() readonly onChange: any;
  
  public menuTabs: IEdTabsMenu[] = [];
  public currentTab : string = '';

  get tabs(): IEdTabsMenu[] {
    return this.menuTabs.filter(t => t.visible);
  }

  get contentTabs(): IEdTabsMenu[] {
    return this.menuTabs;
  }

  get isPresentationStudentMode() : boolean {
    return this.$store.state.CourseStore.isPresentationStudentMode;
  }

  get isPresentationTeacherMode() : boolean {
    return this.$store.state.CourseStore.isPresentationTeacherMode;
  }

  get isBoardSectionHomework() {
    return this.$store.state.CourseStore.isBoardSectionHomework;
  }

  get currentBoardUser() {
    return this.$store.state.MeetingsStore.currentBoardUser;
  }

  get isTeacherScreenUser() {
    return this.currentBoardUser.isTeacher;
  }

  get isCurrentBoardUserTeacher(): boolean {
    return Object.keys(this.currentBoardUser).length === 0 || this.isTeacherScreenUser;
  }

  get offlineMode() : boolean {
    if(this.$store.state.HomeworksStore.isEdupadActive)
      return false
    return this.$store.state.AppStore.offlineMode;
  }

  created() {
    this.setMenuTabs();
  }

  setMenuTabs() {
    this.menuTabs = [...this.menu];
  }

  goToTab(tab: IEdTabsMenu) {   
    if (this.offlineMode) {
      return;
    }
    if(!tab.disabled && this.currentTab !== tab.contentId) {
      this.currentTab = tab.contentId;
      this.menuTabs.forEach(t => t.active = false);
      tab.active = true;
      this.$emit('onChange', tab);
      if(this.isPresentationTeacherMode && this.isCurrentBoardUserTeacher)
        this.$edEventBus.$emit(COURSE_EVENTS.SEND_PRESENTATION_LAYOUT, {elementId: tab.contentId, type: 'tab'});
    }
  }

  setTab(contentId: string) {
    this.menuTabs.forEach(t => {
      t.active = t.contentId == contentId;
      this.currentTab = t.contentId == contentId ? contentId : this.currentTab;
    });
  }

  @Watch('menu')
  menuChanged(value) {
    this.setMenuTabs();
  }

}

export default Vue.component('ed-tabs', EdTabs);